// Import Redux Types
import {
  REGISTER_USER,
  SUCCESS_REGISTER_USER,
  ERROR_REGISTER_USER
} from '../types/index'
// Import Services
import { post } from './../services/api'
// Import Crypto
import { createJWT } from './../utilities/cryptoData'
// Import Actions
import { showLoaderAction } from './generalAction'
import { setDataModalAction, openModalAction } from './modalAction'
import { registerSubmit as registerSubmitDatalayer } from './datalayer'



// Function
export function registerUserAction( data:any, history:any ) {
  return async ( dispatch:any ) => {
    dispatch( registerUser() )
    dispatch( showLoaderAction( true ) )
    try {
      registerSubmitDatalayer(data.registerEmail)
      const dataEncoded = createJWT( data )
      const dataEnd = {
        jwt: dataEncoded
      }
      const response:any = await post('r3g15t3r', dataEnd)
      if( response.status === 'ok' ) history.push('/cempasuchil/crear-ofrenda')
      if( response.status === 'error' ) {
        dispatch( setDataModalAction('message', {
          hasClose: true,
          title: 'Error de autenticación',
          text: 'Lo sentimos! en este momento no puedes registrarte',
          btn: {
            text: 'Recargar',
            link: '[reload]'
          }
        }) )
        dispatch( openModalAction('message') )
      }
      if( response.status === 'registered' ) {
        dispatch( setDataModalAction('message', {
          hasClose: true,
          title: 'Lo sentimos',
          text: 'ya estÁs participando en el sorteo de seis latas con tu dedicatoria. te invitamos a ver otras ofrendas.',
          btn: {
            text: 'ver ofrendas',
            link: '/cempasuchil/ofrendas-vivas'
          }
        }) )
        dispatch( openModalAction('message') )
      }
      dispatch( successRegisterUser( data ) )
    } catch( error ) {
      dispatch( errorRegisterUser() )
    } finally {
      dispatch( showLoaderAction( false ) )
    }
  }
}
const registerUser = () => ({
  type: REGISTER_USER
})
const successRegisterUser = (data:any) => ({
  type: SUCCESS_REGISTER_USER,
  payload: data
})
const errorRegisterUser = () => ({
  type: ERROR_REGISTER_USER
})
